import { MAX_VALUE } from './constants';

export function calculateYLabelValue(value: number, lineDiff: number, minLineValue: number, lineDataRatio: number) {
  if (lineDiff === 0) {
    return lineDataRatio * MAX_VALUE + MAX_VALUE / 2;
  }
  const v2 = (1 - lineDataRatio);

  return ((((value - minLineValue) * v2) / lineDiff) * MAX_VALUE) + (lineDataRatio * MAX_VALUE);
}
